import React, {CSSProperties} from 'react';
import {
    Text,
    Group,
    Stack,
    Divider, 
    ActionIcon,
    Paper,
    useMantineTheme
} from '@mantine/core';
import {Download} from "tabler-icons-react";

import {IAgentSignupDocument} from '../../../api/AgentSignup/AgentSignup.types';
import AgentSignupApi from "../../../api/AgentSignup/AgentSignup.api";

interface Props {
    agentDocuments: IAgentSignupDocument[]
}

function AgentReviewDocuments({agentDocuments}: Props) {
    const theme = useMantineTheme();

    const commonPaperStyle: CSSProperties = {
        position: 'relative',
        width: "100%",
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
        maxWidth: 750,
    }

    if(agentDocuments && agentDocuments.length === 0) {
        return (
            <Paper style={commonPaperStyle}></Paper>
        )
    }

    return (
        <Paper p="sm" style={{...commonPaperStyle}}>
            {agentDocuments &&
                agentDocuments.map((doc: any, index: number) => {
                    return (
                        <Stack key={doc.docId} sx={() => ({
                            "&:not(:first-of-type)": {
                                marginTop: 16
                            }
                        })}>
                            <Group position="apart">
                                <Text size="sm">{doc.docName}</Text>
                                <Group>
                                    <ActionIcon>
                                        <Download size={16} onClick={(e) => {
                                            AgentSignupApi.downloadDocument(doc.docId, doc.docName)
                                            e.stopPropagation();
                                        }}/>
                                    </ActionIcon>
        
                                </Group>
                            </Group>
                            {index !== agentDocuments!.length - 1 &&
                                <Divider m={0}/>}
                        </Stack>
                    )
                })
            }
        </Paper>
    )
}

export default AgentReviewDocuments;